module.exports = __webpack_public_path__ + "static/CDCSR Logo-f9ef8a461af892d8e3eb7444721e80ef.png";